const isImageLoaded = ($img) => {
	if (!$img.complete) return false;
	if (typeof $img.naturalWidth !== 'undefined' && $img.naturalWidth === 0) return false;
	return true;
};

const imageSizeTranslation = (columnWidth = '', imageObj, lazyLoad = true, limitLower = false, imageWidth = false) => {
	const returnObj = {};
	const useLazy = lazyLoad !== false;
	let width = 1;
	columnWidth = columnWidth.toString();
	if (!imageObj || Object.keys(imageObj).length === 0) return {};
	if (imageObj.src) imageObj.url = imageObj.src;
	if (imageObj.url.indexOf('https://images.marsblade.com') !== -1) imageObj.url = imageObj.url.replace('https://images.marsblade.com', 'https://www.marsblade.com');
	if (/\.(svg|gif)$/.test(imageObj.url)) columnWidth = 'noResize';
	const imageName = imageObj.url.slice(0, imageObj.url.lastIndexOf('.'));
	const imageExt = imageObj.url.slice(imageObj.url.lastIndexOf('.'));

	if (useLazy && lazyLoad === 'eager') returnObj.loading = 'eager';
	else if (useLazy) returnObj.loading = 'lazy';
	if (imageWidth !== false) {
		returnObj.src = `${imageName}-${imageWidth}x${imageExt}`;
		returnObj.alt = imageObj.alt;
		returnObj.width = imageWidth;
		if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * imageWidth);
		return returnObj;
	}

	switch (columnWidth) {
		case 'full':
		case '12':
			width = 2600;
			returnObj.src = `${imageName}-2600x${imageExt}`;
			returnObj.srcSet = `${imageName}-2000x${imageExt} 2000w, ${imageName}-1600x${imageExt} 1600w, ${imageName}-1200x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}-800x${imageExt} 800w, ${imageName}-400x${imageExt} 400w`)}`;
			break;
		case '11':
		case '10':
		case '9':
			width = 2200;
			returnObj.src = `${imageName}-2600x${imageExt}`;
			returnObj.srcSet = `${imageName}-2000x${imageExt} 2000w, ${imageName}-1600x${imageExt} 1600w, ${imageName}-1200x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}-800x${imageExt} 800w, ${imageName}-400x${imageExt} 400w`)}`;
			break;
		case '8':
		case '7':
		case '6':
			width = 1800;
			returnObj.src = `${imageName}-1800x${imageExt}`;
			returnObj.srcSet = `${imageName}-1200x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}-800x${imageExt} 800w, ${imageName}-400x${imageExt} 400w`)}`;
			break;
		case '5':
		case '4':
			width = 1200;
			returnObj.src = `${imageName}-1200x${imageExt}`;
			returnObj.srcSet = `${imageName}-800x${imageExt} 800w, ${imageName}-400x${imageExt} 400w`;
			break;
		case '3':
		case '2':
		case '1':
			width = 800;
			returnObj.src = `${imageName}-800x${imageExt}`;
			returnObj.srcSet = `${imageName}-400x${imageExt} 400w`;
			break;
		default:
			width = imageObj.width;
			returnObj.src = imageObj.url;
	}
	returnObj.alt = imageObj.alt;
	returnObj.width = width;
	if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * width);

	return returnObj;
};

const productImageSizeTranslation = (columnWidth = '', image = '', lazyLoad = true, limitLower = false, imageWidth = false) => (
	imageSizeTranslation(columnWidth, { url: image }, lazyLoad, limitLower, imageWidth)
);


export { isImageLoaded, imageSizeTranslation, productImageSizeTranslation };
